import { render, staticRenderFns } from "./Finalize2.vue?vue&type=template&id=b417af98&scoped=true"
import script from "./Finalize2.vue?vue&type=script&lang=js"
export * from "./Finalize2.vue?vue&type=script&lang=js"
import style0 from "./Finalize2.vue?vue&type=style&index=0&id=b417af98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b417af98",
  null
  
)

export default component.exports